import http from "@/axios/http-common";

interface Message {
  status: number;
  message: string;
}

async function cekAlert(rm: string | number): Promise<Message> {
  const { data } = await http.getData(
    `/pasien/${rm}/register-heart-failure/alert`
  );

  return data;
}

async function setTag(rm: string | number): Promise<any> {
  const { data } = await http
    .postData(`/pasien/${rm}/tag`, {
      name: "reg-heart-failure"
    })
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function removeTag(rm: string | number): Promise<any> {
  const { data } = await http
    .deleteData(`/pasien/${rm}/tag/reg-heart-failure`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function getByRegister(reg: string | number): Promise<any> {
  const { data } = await http.getData(
    `/register/${reg}/register-heart-failure`
  );

  return data;
}

async function getByPasien(rm: string | number): Promise<any> {
  const { data } = await http.getData(`/pasien/${rm}/register-heart-failure`);

  return data;
}

function getReport(): void {
  const routeData = http.getAPI() + "/register-heart-failure/report";

  window.open(routeData);
}

async function deleteRegHfItem(id: number): Promise<any> {
  const { data } = await http
    .deleteData(`/register-heart-failure/${id}`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function createRegHfRecord(postData: any): Promise<any> {
  const { data } = await http
    .postData(`/register-heart-failure`, postData)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function updateRegHfRecord(id: number, postData: any): Promise<any> {
  const { data } = await http
    .putData(`/register-heart-failure/${id}`, postData)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

export default {
  cekAlert,
  setTag,
  removeTag,
  getByRegister,
  getByPasien,
  getReport,
  deleteRegHfItem,
  createRegHfRecord,
  updateRegHfRecord
};
